import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrentinpune() {



const cardData = {
  keyword: " Tempo Traveller On Rent in Pune ",

"headingDescription": "Tempo Traveller On Rent in Pune provides spacious, comfortable, and reliable transportation for group travel, family trips, corporate outings, and long-distance journeys. SRS Cab Service offers well-maintained tempo travellers with professional drivers, ensuring a smooth and safe ride across Pune and beyond. Whether it’s a city tour, airport transfer, or weekend getaway, our rental service offers flexible packages, transparent pricing, and 24/7 customer support to make group travel convenient and hassle-free.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort and a key landmark of Pune. Travelers renting a tempo traveller often include this site to explore Pune’s rich Maratha heritage and architectural marvels."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a prominent historical site in Pune associated with India’s freedom struggle. Groups using tempo travellers often visit to enjoy the gardens and museum exhibits."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a scenic hill fort offering trekking and panoramic views. Travelers on rented tempo travellers often plan a visit for adventure and sightseeing."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered religious sites. Groups traveling by tempo traveller often stop here to experience the spiritual atmosphere."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut temple in Pune. Visitors using tempo travellers enjoy its peaceful surroundings and historical significance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum showcases a large collection of Indian artifacts. Groups on tempo travellers explore this museum to understand Pune’s cultural and artistic heritage."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple offers panoramic city views and historical temples. Travelers using tempo travellers often climb the hill for sightseeing and leisure."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a serene spot for relaxation and photography. Groups on tempo travellers often include this location in their itinerary for peace and natural beauty."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden is a Japanese-style landscaped garden ideal for walking and relaxation. Visitors traveling in tempo travellers enjoy its greenery and calm ambiance."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic site connected to Chhatrapati Shivaji Maharaj. Travelers using tempo travellers often visit this landmark to learn about Pune’s historical legacy."
  }
],



services: [
{
name: "17 Seater Tempo Traveller on Rent in Pune",
description: "17 seater tempo traveller on rent in Pune offers comfortable group travel for tours and events. Customers can book spacious vehicles for family and corporate trips. Professional drivers ensure safe journeys. Comfortable seating enhances travel experience. Flexible booking options are available. Travel easily with 17 seater tempo traveller rentals."
},
{
name: "13 Seater Tempo Traveller on Rent in Pune",
description: "13 seater tempo traveller on rent in Pune provides ideal travel for small groups. Customers can book vehicles for trips and outings. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with 13 seater tempo traveller services."
},
{
name: "Traveller on Rent Pune",
description: "Traveller on rent Pune offers convenient group travel solutions for all occasions. Customers can book vehicles for tours and events. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with traveller rentals in Pune."
},
{
name: "Traveller Bus on Rent in Pune",
description: "Traveller bus on rent in Pune provides large group transportation for trips and events. Customers can book buses for comfortable journeys. Professional drivers ensure safe travel. Spacious seating enhances experience. Flexible booking options are available. Travel easily with traveller bus rentals."
},
{
name: "17 Seater Bus Rate per km in Pune",
description: "17 seater bus rate per km in Pune provides clear pricing for travel planning. Customers can check per km rates before booking. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose bus rentals with transparent pricing."
},
{
name: "17 Seater Tempo Traveller in Pune",
description: "17 seater tempo traveller in Pune offers reliable group travel for tours and events. Customers can book vehicles for comfortable journeys. Professional drivers ensure safe travel. Spacious seating enhances experience. Flexible booking options are available. Travel easily with 17 seater traveller services."
},
{
name: "17 Seater Tempo Traveller on Rent Pune",
description: "17 seater tempo traveller on rent Pune provides convenient travel for groups. Customers can book vehicles for tours and functions. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller rentals."
},
{
name: "20 Seater Tempo Traveller Pune",
description: "20 seater tempo traveller Pune offers spacious travel for large groups. Customers can book vehicles for tours and corporate events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with 20 seater tempo traveller services."
},
{
name: "20 Seater Bus on Rent in Pune",
description: "20 seater bus on rent in Pune provides large group transportation for events and tours. Customers can book buses for comfortable journeys. Professional drivers ensure safe travel. Spacious seating enhances experience. Flexible booking options are available. Travel easily with bus rental services."
},
{
name: "25 Seater Bus Rate per km Pune",
description: "25 seater bus rate per km Pune provides pricing details for large group travel. Customers can check rates before booking. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose bus rentals with transparent pricing."
},
{
name: "AC Tempo Traveller on Rent in Pune",
description: "AC tempo traveller on rent in Pune offers comfortable travel with air conditioning. Customers can book vehicles for long-distance journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with AC tempo traveller services."
},
{
name: "Book Tempo Online Pune",
description: "Book tempo online Pune offers easy and quick reservation options. Customers can book tempo travellers digitally. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your tempo traveller online easily."
},
{
name: "Book Tempo Traveller in Pune",
description: "Book tempo traveller in Pune provides convenient booking for group travel. Customers can reserve vehicles for tours and events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Book your tempo traveller easily."
},
{
name: "Hire Tempo in Pune",
description: "Hire tempo in Pune offers flexible travel solutions for group transportation. Customers can hire vehicles for trips and functions. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Hire tempo services easily in Pune."
},
{
name: "Hire Tempo Traveller in Pune",
description: "Hire tempo traveller in Pune provides reliable transportation for group travel. Customers can hire vehicles for tours and events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Hire tempo traveller services easily."
},
{
name: "Luxury Tempo Traveller on Rent in Pune",
description: "Luxury tempo traveller on rent in Pune offers premium travel experience for groups. Customers can enjoy high-end vehicles with extra comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel comfortably with luxury tempo travellers."
},
{
name: "Pune Tempo Traveller Hire for Outstation",
description: "Pune tempo traveller hire for outstation provides long-distance group travel solutions. Customers can book vehicles for tours and trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with outstation tempo traveller services."
},
{
name: "Pune to Mahabaleshwar Tempo Traveller",
description: "Pune to Mahabaleshwar tempo traveller offers comfortable travel for hill station trips. Customers can book vehicles for group tours. Professional drivers ensure safe ghat road journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Mahabaleshwar."
},
{
name: "Pune to Shirdi Tempo Traveller Rate",
description: "Pune to Shirdi tempo traveller rate provides pricing details for group travel. Customers can check rates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Travel easily with tempo traveller services."
}
],

tableData: [
["17 Seater Tempo Traveller on Rent in Pune","13 Seater Tempo Traveller on Rent in Pune"],
["Traveller on Rent Pune","Traveller Bus on Rent in Pune"],
["17 Seater Bus Rate per km in Pune","17 Seater Tempo Traveller in Pune"],
["17 Seater Tempo Traveller on Rent Pune","20 Seater Tempo Traveller Pune"],
["20 Seater Bus on Rent in Pune","25 Seater Bus Rate per km Pune"],
["AC Tempo Traveller on Rent in Pune","Book Tempo Online Pune"],
["Book Tempo Traveller in Pune","Hire Tempo in Pune"],
["Hire Tempo Traveller in Pune","Luxury Tempo Traveller on Rent in Pune"],
["Pune Tempo Traveller Hire for Outstation","Pune to Mahabaleshwar Tempo Traveller"],
["Pune to Shirdi Tempo Traveller Rate","17 Seater Tempo Traveller on Rent in Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Best Group Travel Solution in Pune",
    WhyChoosedescription: "SRS Cab Service offers spacious Tempo Traveller on rent in Pune, perfect for family trips, corporate outings, weddings, and group tours with comfortable seating."
  },
  {
    WhyChooseheading: "Affordable Tempo Traveller Rental Pricing",
    WhyChoosedescription: "We provide budget-friendly Tempo Traveller rental in Pune with transparent pricing. Rates typically start from around ₹20–₹30 per km depending on vehicle type and seating capacity. :contentReference[oaicite:0]{index=0}"
  },
  {
    WhyChooseheading: "Multiple Seating Options Available",
    WhyChoosedescription: "Choose from 9, 12, 13, 17, 20, and 26 seater Tempo Travellers, suitable for small to large groups, ensuring comfortable and convenient travel for everyone."
  },
  {
    WhyChooseheading: "Luxury & AC Tempo Traveller Options",
    WhyChoosedescription: "We offer AC, pushback seat, Maharaja, and luxury Tempo Traveller variants equipped with modern amenities like music system, LED TV, and spacious interiors. :contentReference[oaicite:1]{index=1}"
  },
  {
    WhyChooseheading: "24/7 Tempo Traveller Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Tempo Traveller bookings in Pune, making it easy to plan trips anytime for local sightseeing, outstation tours, and events."
  },
  {
    WhyChooseheading: "Perfect for Outstation & Tour Packages",
    WhyChoosedescription: "Our Tempo Travellers are ideal for Pune to Mahabaleshwar, Lonavala, Shirdi, Goa, and Konkan trips, offering comfortable long-distance travel for groups."
  },
  {
    WhyChooseheading: "Professional Drivers for Group Travel",
    WhyChoosedescription: "We provide experienced and courteous drivers who are familiar with Pune routes and outstation highways, ensuring safe and smooth group travel."
  },
  {
    WhyChooseheading: "Trusted Tempo Traveller Rental in Pune",
    WhyChoosedescription: "SRS Cab Service is trusted for Tempo Traveller on rent in Pune due to reliable service, clean vehicles, and comfortable group travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Tempo Traveller on rent in Pune?", answer: "Yes, SRS Cab Service offers Tempo Traveller rental in Pune for local and outstation travel." },
  { question: "What is the price of Tempo Traveller in Pune?", answer: "Tempo Traveller rental in Pune starts from approximately ₹20 to ₹30 per km depending on seating and type." },
  { question: "Which seating options are available?", answer: "We provide 9, 12, 13, 17, 20, and 26 seater Tempo Travellers." },
  { question: "Is Tempo Traveller available for outstation trips?", answer: "Yes, we provide Tempo Traveller for outstation travel like Lonavala, Mahabaleshwar, Shirdi, Goa, and more." },
  { question: "Are Tempo Travellers AC?", answer: "Yes, we provide both AC and Non-AC Tempo Traveller options with comfortable seating." },
  { question: "Do you provide Tempo Traveller for weddings and corporate events?", answer: "Yes, Tempo Travellers are available for weddings, corporate events, and group travel." },
  { question: "Is Tempo Traveller available 24/7?", answer: "Yes, our service operates 24 hours a day for flexible booking." },
  { question: "What facilities are available in Tempo Traveller?", answer: "Facilities include AC, pushback seats, music system, and spacious seating for comfort." },
  { question: "Can I book Tempo Traveller online?", answer: "Yes, you can easily book Tempo Traveller online or via phone." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all Tempo Travellers are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Jadhav",
    feedback:
      "Booked Tempo Traveller from SRS Cab Service for Lonavala trip. Very comfortable and perfect for group travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Riya Kulkarni",
    feedback:
      "Best Tempo Traveller rental in Pune. Clean vehicle, professional driver, and smooth journey.",
    rating: 5
  }
];
































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller On Rent in Pune | SRS Cab",
  "description": "SRS Cab offers Tempo Traveller on rent in Pune including 13, 17, 20, and 25 seater options. Hire AC or non-AC tempo travellers for outstation trips, corporate events, family tours, and temple visits. Book online for Pune to Mahabaleshwar, Pune to Shirdi, and other destinations with affordable rates per km and 24x7 booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Tempo Traveller On Rent in Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Hire Tempo Traveller on rent in Pune with SRS Cab. 13, 17, 20, and 25 seater AC/non-AC options for outstation trips, corporate events, family tours, and temple visits. Book online for Pune to Mahabaleshwar, Pune to Shirdi, and other destinations. Affordable rates per km with 24x7 booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/29.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravelleronrentinpune;